import { Box } from "@mui/material";
import { TcuConfirmationCardProps } from "./TcuConfirmationCard.types";
import CardWrapper from "../../../../common/cards/CardWrapper/CardWrapper";
import AppointmentCardHeader from "ui/appointment/components/common/cards/AppointmentCardHeader/AppointmentCardHeader";
import TcuAppointmentCardBody from "ui/appointment/components/common/cards/TcuAppointmentCardBody/TcuAppointmentCardBody";

const TcuConfirmationCard = ({
  slotDateTime,
  institution,
  service,
}: TcuConfirmationCardProps) => {
  return (
    <CardWrapper isLinkedAppointmentStyled={false}>
      <Box sx={{ display: "flex" }}>
        <AppointmentCardHeader datetime={slotDateTime} isHighlighted={true} />
        <TcuAppointmentCardBody
          institution={institution || ""}
          datetime={slotDateTime}
          serviceDisplayName={service}
          apptStatusTag="BOOKED"
        />
      </Box>
    </CardWrapper>
  );
};

export default TcuConfirmationCard;
